import { useAuth } from "../auth/AuthProvider";
import { effectiveTimeZone, formatTime, formatWhen } from "./preferences";

/** Dates and times in the signed-in user's zone and format (section 13.1). */
export function useFormat() {
  const { preferences } = useAuth();
  return {
    timeZone: effectiveTimeZone(preferences),
    when: (iso: string) => formatWhen(iso, preferences),
    date: (iso: string) => formatWhen(iso, preferences, false),
    time: (iso: string | number) => formatTime(iso, preferences),
  };
}
